import { readCookie } from "./preambleReadCookie";

// updates color-scheme according to cookie for guest users on edge-cached pages
const styleCookie = readCookie("style_id");
const { styleIdLight } = document.documentElement.dataset;
if (styleCookie && styleIdLight) {
  document.documentElement.dataset.colorScheme =
    styleCookie === styleIdLight ? "light" : "dark";
}
